import { render, staticRenderFns } from "./DashLeftMenu.vue?vue&type=template&id=48de2e4c"
import script from "./DashLeftMenu.vue?vue&type=script&lang=js"
export * from "./DashLeftMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports